
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business-solutions/[url_slug]",
      function () {
        return require("private-next-pages/business-solutions/[url_slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business-solutions/[url_slug]"])
      });
    }
  